import {
  Environment
} from '@vodacom/web-env';

import {
  AppState,
  getStorageWithExpiry,
  isValidEncMsisdn,
  setStorageWithExpiry
} from 'helpers';

import {
  CacheKeys,
  CacheStrategy,
  JavascriptTypes
} from '../../../constants';

export class BundleProvider {

  static STATE = AppState.with('BundleProvider');
  static BASE_URL = Environment.current.j4uHost;
  static BASE_URL_V3 = Environment.current.j4uHostv3;

  static DEFAULT_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'x-api-channel': 'CONNECTU'
  };

  static getMsisdn() {

    return getStorageWithExpiry('msisdn', 'encMsisdn', '');
  }

  static async getOffers() {

    if (!isValidEncMsisdn(BundleProvider.getMsisdn())) {

      setStorageWithExpiry('offers', CacheKeys.Offers, 'No offers', false, 60 * 5 * 1000);

      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return BundleProvider.STATE.makeServiceCall(
      `${BundleProvider.BASE_URL}/bundles`,
      {
        method: 'POST',
        headers: {
          ...BundleProvider.DEFAULT_HEADERS
        },
        bodyParams: {
          'id': BundleProvider.getMsisdn()
        },
        cacheStrategy: CacheStrategy.NetworkFirst
      }
    )
    .then((res) => {

      if (!res.result || res?.result?.vasList?.length === 0) {

        setStorageWithExpiry('offers', CacheKeys.Offers, 'No offers', false, 60 * 5 * 1000);

        return {
          ok: false,
          error: new Error('offers verification error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      setStorageWithExpiry('offers', CacheKeys.Offers, res, false, 60 * 10 * 1000);

      return res;
    })
    .catch((error) => {

      setStorageWithExpiry('offers', CacheKeys.Offers, 'No offers', false, 60 * 5 * 1000);

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    });
  }

  static async verifyOtp(otp, vasCode) {

    return BundleProvider.STATE.makeServiceCall(
      `${BundleProvider.BASE_URL}/bundles/allocation`,
      {
        method: 'POST',
        headers: {
          ...BundleProvider.DEFAULT_HEADERS
        },
        bodyParams: {
          'id': BundleProvider.getMsisdn(),
          'pto': otp,
          'vasCode': vasCode
        }
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('J4U bundle allocation error'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async verifyOtpv2(otp, vasCode) {

    return BundleProvider.STATE.makeServiceCall(
      `${BundleProvider.BASE_URL_V3}/bundles/allocation`,
      {
        method: 'POST',
        headers: {
          ...BundleProvider.DEFAULT_HEADERS
        },
        bodyParams: {
          'id': BundleProvider.getMsisdn(),
          'pto': otp,
          'vasCode': vasCode
        }
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('J4U bundle allocation error'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: error?.response?.data,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async getCachedItem(key, fallback, serviceFallback) {

    const cachedItem = getStorageWithExpiry('offers', key, fallback);

    if (!cachedItem && serviceFallback && typeof serviceFallback === JavascriptTypes.Function) {

      const response = await serviceFallback();

      if (response.ok && response.result) {

        return response;
      }
    }

    return cachedItem;
  }
}
